import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import DateBox from 'devextreme-react/date-box';
import "../Maintenence/EditSeedInventory.css";
import axios from "axios";
import routes from "../../../assets/apiRoutes.json";
import EditSeedInventoryDialog from "../Dialoges/EditSeedInventoryDialog";
import SelectBox from 'devextreme-react/select-box';
import TextBox from 'devextreme-react/text-box';
import NumberBox from 'devextreme-react/number-box';
import { Button } from 'devextreme-react/button';
import {
  Validator,
  RequiredRule,
} from 'devextreme-react/validator';

const EditSeedInventory = (props) => {
  var accessToken = props.oidc.user.access_token;
  const [speciesLookupData, setSpeciesLookupData] = useState([]);
  const [warehouseLookupData, setWarehouseLookupData] = useState([]);
  const [seedItemsLookupData, setSeedItemsLookupData] = useState([]);
  const [seedLotsLookupData, setSeedLotsLookupData] = useState([]);
  const [locationLookupData, setLocationLookupData] = useState([]);
  const selectedCompanyName =
    props.ReceiptReducer.selectedCompanyName !== "" &&
      props.ReceiptReducer.selectedCompanyName != undefined
      ? props.ReceiptReducer.selectedCompanyName
      : "SB";
  const [editSeedInventory, setEditSeedInventory] = useState({
    warehouse: "",
    itemSpecies: "",
    location: "",
    adjustdate: new Date(),
    netavaliable: 0,
    avaliable: 0,
    adjustqty: null,
    adjustafterqty: 0,
    salesorder: "",
    rowid: "",
    adjusttype: "",
    adjustreason: "",
    seeditem: "",
    seedlot: "",
    companyid: selectedCompanyName,
    lastupdateuserid: props.oidc.user.profile.email,
    creationuserid: props.oidc.user.profile.email,
  });
  var adjustTypes = [
    "Weyer Seed Sale",
    "Cust Seed Sale",
    "Cust Transfer Request",
    "Weyer Inv Adjustment",
    "Cust inv Adjustment",
  ];
  const fetchSpeciesLookups = () => {
    axios
      .get(
        `${window._env_.REACT_APP_APIS}/${routes.maintenance.FetchSpeciesLookup}`,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          },
        }
      )
      .then((res) => {
        setSpeciesLookupData(res.data);
      })
      .catch((err) => {
        console.log(err, "species error");
      });
  };
  const fetchWarehouseLookups = () => {
    axios
      .get(
        `${window._env_.REACT_APP_APIS}/${routes.maintenance.FetchWarehouseLookup}`,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          },
        }
      )
      .then((res) => {
        setWarehouseLookupData(res.data);
      })
      .catch((err) => {
        console.log(err, "warehouse error");
      });
  };
  const fetchSeedItemsLookups = (speciesCode, warehouse) => {
    axios
      .get(
        `${window._env_.REACT_APP_APIS}/${routes.maintenance.FetchSeedItemsLookup}?speciescd=${speciesCode}&warehouse=${warehouse}`,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          },
        }
      )
      .then((res) => {
        setSeedItemsLookupData(res.data);
      })
      .catch((err) => {
        console.log(err, "seeditems error");
      });
  };

  const fetchSeedLotsLookups = (speciesCode, warehouse, seedItem) => {
    axios
      .get(
        `${window._env_.REACT_APP_APIS}/${routes.maintenance.FetchSeedLotsLookup}?speciescd=${speciesCode}&warehouse=${warehouse}&seeditem=${seedItem}`,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          },
        }
      )
      .then((res) => {
        setSeedLotsLookupData(res.data);
      })
      .catch((err) => {
        console.log(err, "seedlots error");
      });
  };
  const fetchLocationLookups = (speciesCode, warehouse, seedItem, seedLot) => {
    axios
      .get(
        `${window._env_.REACT_APP_APIS}/${routes.maintenance.FetchLocationLookup}?speciescd=${speciesCode}&warehouse=${warehouse}&seeditem=${seedItem}&seedlot=${seedLot}`,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          },
        }
      )
      .then((res) => {
        setLocationLookupData(res.data);
      })
      .catch((err) => {
        console.log(err, "location error");
      });
  };
  useEffect(() => {
    fetchSpeciesLookups();
    fetchWarehouseLookups();
  }, []);

  const {
    warehouse,
    itemSpecies,
    location,
    adjustreason,
    adjustdate,
    netavaliable,
    avaliable,
    adjustqty,
    adjustafterqty,
    salesorder,
    adjusttype,
    rowid,
    seeditem,
    seedlot,
    companyid,
    lastupdateuserid,
    creationuserid,
  } = editSeedInventory;
  const onInputChange = (e, ctrlName) => {
    if (ctrlName === "adjustqty") {
      let avlbl = Number.isNaN(avaliable) ? 0 : avaliable;
      let adjustQuantity = avlbl + Number(e.value);
      adjustQuantity = Number.isNaN(adjustQuantity) ? 0 : adjustQuantity.toFixed(2);
      setEditSeedInventory({
        ...editSeedInventory,
        adjustafterqty: adjustQuantity,
        adjustqty: e.value
      });
    } else {
      setEditSeedInventory({
        ...editSeedInventory,
        [ctrlName]: e.value,
      });
    }
  };
  const onValChangeDtBx = (e) => {
    setEditSeedInventory({
      ...editSeedInventory,
      ['adjustdate']: e.value,
    });
  };

  const [openSeedInventory, setOpenSeedInventory] = useState(false);
  const [locationDetails, setLocationDetails] = useState({});

  const openEditSeedInventoryDialog = () => {
    setOpenSeedInventory(true);
  };
  const resetAddSeedLot = () => {
    setEditSeedInventory({
      warehouse: "",
      itemSpecies: "",
      location: "",
      seeditem: "",
      seedlot: "",
      adjustdate: new Date(),
      netavaliable: 0,
      avaliable: 0,
      adjustqty: null,
      adjustafterqty: 0,
      salesorder: "",
      adjusttype: "",
      adjustreason: "",
      companyid: selectedCompanyName,
      lastupdateuserid: props.oidc.user.profile.email,
      creationuserid: props.oidc.user.profile.email,
    });
  };

  const speciesChangeHandle = (e) => {
    setEditSeedInventory({
      warehouse: "",
      ...editSeedInventory,
      ["itemSpecies"]: e?.selectedItem.itemCodeSpecies,
    });
  };
  const adjusttypeChangeHandle = (e) => {
    setEditSeedInventory({
      ...editSeedInventory,
      ["adjusttype"]: e?.selectedItem,
    });
  };
  
  const warehouseChangeHandle = (e) => {
    setEditSeedInventory({
      ...editSeedInventory,
      ["warehouse"]: e?.selectedItem,
    });
    fetchSeedItemsLookups(getSeedItmCd(), e?.selectedItem);
  };
  const seedItemChangeHandle = (e) => {
    setEditSeedInventory({
      ...editSeedInventory,
      ["seeditem"]: e?.selectedItem.item,
    });

    fetchSeedLotsLookups(getSeedItmCd(), editSeedInventory.warehouse, e?.selectedItem.item);
  };
  const getItemSpec = () => {
    let firstdashIndex = editSeedInventory.itemSpecies.indexOf('-');

    if (firstdashIndex >= 0) {
      return editSeedInventory.itemSpecies.slice(firstdashIndex + 1);
    }
    else {
      return "";
    }
  };
  const getSeedItmCd = () => {
    let firstdashIndex = editSeedInventory.itemSpecies.indexOf('-');

    if (firstdashIndex >= 0) {
      return editSeedInventory.itemSpecies.slice(0, firstdashIndex);
    }
    else {
      return "";
    }
  };
  const seedLotChangeHandle = (e) => {
    setEditSeedInventory({
      ...editSeedInventory,
      ["seedlot"]: e?.selectedItem.seedLot,
    });

    fetchLocationLookups(getSeedItmCd(), editSeedInventory.warehouse, editSeedInventory.seeditem, e?.selectedItem.seedLot);
  };
  const locationChangeHandle = (e) => {
    let locwarehouse = e?.selectedItem.location;
    setEditSeedInventory({
      ...editSeedInventory,
      ["location"]: locwarehouse,
    });
    var dtlObj = {
      warehouse: editSeedInventory.warehouse,
      itemSpecies: getItemSpec(),
      location: locwarehouse,
      seeditem: editSeedInventory.seeditem,
      seedlot: editSeedInventory.seedlot,
      itemcode: getSeedItmCd()
    };
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${routes.maintenance.GetLocationLookupDetails}`,
        dtlObj,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          },
        }
      )
      .then((res) => {
        if (res.data != null && res.data != undefined) {
          setEditSeedInventory({
            ...editSeedInventory,
            ['location']: locwarehouse,
            ['netavaliable']: res.data.netavaliable,
            ['avaliable']: res.data.avaliable,
            ['rowid']: res.data.rowid
          });
        }
        console.log(res.data, "details");
      })
      .catch((err) => {
        console.log(err, "err in details");
      });
  };

  const saveSeedInventory = (e) => {
    e.preventDefault();
    let adjustQuantityRequest = {
      ...editSeedInventory
    }
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${routes.maintenance.UpdateAdjustQuantity}`,
        adjustQuantityRequest,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          },
        }
      )
      .then((res) => {
        openEditSeedInventoryDialog();
        resetAddSeedLot();
      })
      .catch((err) => {
        console.log(err, "err in save record");
      });
  };
  const closeEditSeedInventoryDialog = () => {
    setOpenSeedInventory(false);
  };
  return (
    <div className="m-0 h-100 overflow-hidden" style={{ width: "100%" }}>
       <div className="title">
                        <h6
                          style={{
                            color: window._env_.Color2
                          }}
                        >
                        Edit Seed Inventory
                        </h6>
                      </div>
      <div className="card-container">
        <div className="card-content">
          <form className="addlot-form" onSubmit={(e) => saveSeedInventory(e)}>
            <div className="row">
              <div className="col-md-6">
                <SelectBox
                  value={itemSpecies}
                  name="itemSpecies"
                  onSelectionChanged={(e) => speciesChangeHandle(e)}
                  dataSource={speciesLookupData}
                  displayExpr="itemCodeSpecies"
                  valueExpr="itemCodeSpecies"
                  stylingMode='outlined'
                  labelMode="static"
                  label="Species:">
                  <Validator>
                    <RequiredRule message="Please fill Species." />
                  </Validator>
                </SelectBox>
              </div>
              <div className="col-md-6">
                <DateBox
                  onValueChanged={(e) => onValChangeDtBx(e)}
                  type="date"
                  value={adjustdate}
                  id="adjust-date"
                  name="adjustdate"
                  stylingMode='outlined'
                  labelMode="static"
                  label="Adjust Date:">
                  <Validator>
                    <RequiredRule message="Please fill Adjust Date." />
                  </Validator>
                </DateBox>
              </div>
            </div>
            <div className="row accordianLastRow">
              <div className="col-md-6">
                <SelectBox
                  value={warehouse}
                  name="warehouse"
                  onSelectionChanged={(e) => warehouseChangeHandle(e)}
                  dataSource={warehouseLookupData}
                  stylingMode='outlined'
                  labelMode="static"
                  label="Warehouse:">
                  <Validator>
                    <RequiredRule message="Please fill Warehouse." />
                  </Validator>
                </SelectBox>
              </div>
              <div className="col-md-6">
                <TextBox
                  id="net-available"
                  type="text"
                  onValueChanged={(e) => onInputChange(e, 'netavaliable')}
                  name="netavaliable"
                  value={netavaliable}
                  disabled={true}
                  stylingMode="outlined"
                  labelMode="static"
                  label="Net Available:">
                  <Validator>
                    <RequiredRule message="Please fill Net Available." />
                  </Validator>
                </TextBox>
              </div>
            </div>
            <div className="row accordianLastRow">
              <div className="col-md-6">
                <SelectBox
                  value={seeditem}
                  name="seeditem"
                  onSelectionChanged={(e) => seedItemChangeHandle(e)}
                  dataSource={seedItemsLookupData}
                  displayExpr="item"
                  valueExpr="item"
                  stylingMode="outlined"
                  labelMode="static"
                  label="Seed Item:">
                  <Validator>
                    <RequiredRule message="Please fill Seed Item." />
                  </Validator>
                </SelectBox>
              </div>
              <div className="col-md-6">
                <TextBox
                  id="avaiable"
                  onValueChanged={(e) => onInputChange(e, 'avaliable')}
                  type="text"
                  name="avaliable"
                  value={avaliable}
                  disabled={true}
                  stylingMode="outlined"
                  labelMode="static"
                  label="Available:">
                  <Validator>
                    <RequiredRule message="Please fill Available." />
                  </Validator>
                </TextBox>
              </div>
            </div>
            <div className="row accordianLastRow">
              <div className="col-md-6">
                <SelectBox
                  value={seedlot}
                  name="seedlot"
                  onSelectionChanged={(e) => seedLotChangeHandle(e)}
                  dataSource={seedLotsLookupData}
                  displayExpr="seedLot"
                  valueExpr="seedLot"
                  stylingMode="outlined"
                  labelMode="static"
                  label="Seed Lot:">
                  <Validator>
                    <RequiredRule message="Please fill Seed Lot." />
                  </Validator>
                </SelectBox>
              </div>
              <div className="col-md-6">
                <NumberBox
                  id="adjust-qty"
                  onValueChanged={(e) => onInputChange(e, 'adjustqty')}
                  type="text"
                  name="adjustqty"
                  value={adjustqty}
                  stylingMode="outlined"
                  labelMode="static"
                  label="Adjust Qty:">
                  <Validator>
                    <RequiredRule message="Please fill Adjust Qty." />
                  </Validator>
                </NumberBox>
              </div>
            </div>
            <div className="row accordianLastRow">
              <div className="col-md-6">
                <SelectBox
                  value={location}
                  name="location"
                  onSelectionChanged={(e) => locationChangeHandle(e)}
                  dataSource={locationLookupData}
                  displayExpr="location"
                  valueExpr="location"
                  stylingMode="outlined"
                  labelMode="static"
                  label="Location:">
                  <Validator>
                    <RequiredRule message="Please fill Location." />
                  </Validator>
                </SelectBox>
              </div>
              <div className="col-md-6">
                <TextBox
                  id="new-qty"
                  onValueChanged={(e) => onInputChange(e, 'adjustafterqty')}
                  name="adjustafterqty"
                  type="text"
                  value={adjustafterqty}
                  disabled={true}
                  stylingMode="outlined"
                  labelMode="static"
                  label="New Qty:">
                  <Validator>
                    <RequiredRule message="Please fill New Qty." />
                  </Validator>
                </TextBox>
              </div>
            </div>
            <div className="row accordianLastRow">
              <div className="col-md-6">
                <TextBox
                  id="adjust-reason"
                  onValueChanged={(e) => onInputChange(e, 'adjustreason')}
                  name="adjustreason"
                  value={adjustreason}
                  stylingMode="outlined"
                  labelMode="static"
                  label="Adjustment Reason">
                  <Validator>
                    <RequiredRule message="Please fill Adjustment Reason." />
                  </Validator>
                </TextBox>
              </div>
              <div className="col-md-6">
                <TextBox
                  id="sale-order"
                  onValueChanged={(e) => onInputChange(e, 'salesorder')}
                  name="salesorder"
                  value={salesorder}
                  stylingMode="outlined"
                  labelMode="static"
                  label="Sales Order:">
                  <Validator>
                    <RequiredRule message="Please fill Sales Order." />
                  </Validator>
                </TextBox>
              </div>
            </div>
            <div className="row accordianLastRow">
              <div className="col-md-6">

              </div>
              <div className="col-md-6">
                <SelectBox
                  value={adjusttype}
                  name="adjusttype"
                  onSelectionChanged={(e) => adjusttypeChangeHandle(e)}
                  dataSource={adjustTypes}
                  stylingMode="outlined"
                  labelMode="static"
                  label="Adjust Type:">
                  <Validator>
                    <RequiredRule message="Please fill Adjust Type." />
                  </Validator>
                </SelectBox>
              </div>
            </div>
            <div className="row accordianLastRow">
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-12">
                  <Button
                      type="default"
                      stylingMode="contained"
                      useSubmitBehavior={true}
                      text="Post Record" />
                                <Button
                                    onClick={resetAddSeedLot}
                                    style={{marginLeft:'10px'}}
                                    text="Reset"
                                    useSubmitBehavior={false}
                                    stylingMode="contained">
                                </Button>
               
                  </div>
                
                </div>
              </div>
            </div>
          </form>
        </div>
        <EditSeedInventoryDialog
          openSeedInventory={openSeedInventory}
          openEditSeedInventoryDialog={openEditSeedInventoryDialog}
          closeEditSeedInventoryDialog={closeEditSeedInventoryDialog}
        />
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
    SodReducer: state.SodReducer,
  };
}
export default connect(mapStateToProps)(EditSeedInventory);
